import React from "react";
import AccountSettings from "../../components/AccountSettings";
import HeaderApp from "../../components/HeaderApp";

const Profile = () => {

  return (
    <>
      <HeaderApp/>
      <AccountSettings />
    </>
  );
};

export default Profile;
